import { Pipe, PipeTransform } from '@angular/core';
import { SessionDataService } from 'inova-front-core/session'

@Pipe({
  name: 'userLanguage'
})
export class UserLanguagePipe implements PipeTransform {

  constructor(private sessionDataService:SessionDataService) {}

  transform(value: any, ...args: any[]): any {
    const re = /\[\[(.+?)]]/gm;
    if (value) {
      const match = value.match(re) || [];
      match.forEach((item:any) => {
        const keyName = item.replace('[[', '').replace(']]', '');
        const key = this.sessionDataService.getUserLanguageWord(keyName);
        if (key) {
          value = value.replace(item, key);
        }
      });
    }
    return value;
  }

}
